import { render, staticRenderFns } from "./New_ProductsBox.vue?vue&type=template&id=823e0f64&scoped=true&"
import script from "./New_ProductsBox.vue?vue&type=script&lang=js&"
export * from "./New_ProductsBox.vue?vue&type=script&lang=js&"
import style0 from "./New_ProductsBox.vue?vue&type=style&index=0&id=823e0f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823e0f64",
  null
  
)

export default component.exports